module.exports = __webpack_public_path__ + "static/media/ic_chevron_left.2f0d6553.svg";